import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PgErrorsComponent } from '../../pg-help/pg-errors/pg-errors.component';
import { EnvironmentService } from '../../services/environment.service';
import { NotificationsService, PGNotification } from '../../services/notifications.service';
import { ClipboardService } from '../../pg-ui-elements/clipboard.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { LocalizationService } from '../../services/localization.service';
import { PgFooterStatus, PgFooterStatusService } from '../pg-footer-status.service';
import { PwaInstallService } from '../../pg-ui-elements/pwa-install.service';
import { PersistenceService } from '../../services/persistence.service';

@Component({
    selector: 'app-pg-footer',
    templateUrl: './pg-footer.component.html',
    styleUrls: ['./pg-footer.component.scss'],
    standalone: false
})
export class PgFooterComponent implements OnInit, AfterViewInit {

    constructor(private notificationsService:NotificationsService, private environmentService:EnvironmentService, private authService:AuthService, private clipboardService:ClipboardService, private modalService:NgbModal, private router:Router, private localizationService:LocalizationService, private pgFooterStatusService:PgFooterStatusService, private pwaInstallService:PwaInstallService, private persistenceService:PersistenceService) { }

    isHidden:boolean = false;

    notifications:Array<PGNotification> = [];

    noLinks = false;

    appLogo:string = null;
    appProvider:string = null;

    footerLogo:string = null;
    footerLarge:boolean = null;

    installButtonShow = false;

    isSwitchingLanguage = false;

    ngOnInit() {
        this.appLogo = this.environmentService.environment.AppLogo;
        this.appProvider = this.environmentService.environment.AppProvider;

        if(this.environmentService.environment.AppMode == 'kiosk' || this.environmentService.ElectronWrapper != null) {
            this.noLinks = true;
        }
        
        for(let _notification of this.notificationsService.notifications) {
            if(_notification.type == 'system' || _notification.local) {
                this.notifications.push(_notification)
            }
        }
        
        this.notificationsService.onNotification.subscribe((change) => {
            if(change.operation == 'add') {
                this.notifications.unshift(change.notification)
            }
            else if(change.operation == 'del') {
                for(let i = 0; i < this.notifications.length; i++) {
                    if(this.notifications[i].id == change.notification.id) {
                        this.notifications.splice(i, 1);
                        break;
                    }
                }
            }
        })

        this._generateFooterStatus()

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this._generateFooterStatus()
            }
        })

        this.pgFooterStatusService.statusChange.subscribe(() => {
            console.log('pgFooterStatusService.statusChange')
            this._generateFooterStatus()
        })

        this.localizationService.currentLanguageChange.subscribe((status) => {
            this.isSwitchingLanguage = true;
            setTimeout(() => {
                this.isSwitchingLanguage = false;
            }, 250)
        })
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.installButtonShow = true;
            setTimeout(() => {
                this.installButtonShow = false
            }, 5000)
        }, 1000)
    }

    private _getCurrentRoute() {
        let _currentRoute = this.router.routerState.snapshot.root;
        while(_currentRoute.firstChild != null) _currentRoute = _currentRoute.firstChild;

        return _currentRoute
    }

    private _generateFooterStatus() {
        let _customizationStatus:PgFooterStatus = {};
        
        if(this.pgFooterStatusService.status != null) {
            _customizationStatus = JSON.parse(JSON.stringify(this.pgFooterStatusService.status));
        }
        
        let _currentRoute = this._getCurrentRoute();

        if(_currentRoute.data?.footer != null) {
            for(let i in _currentRoute.data.footer) {
                let _val = _currentRoute.data.footer[i]

                if(typeof _val == 'function') {
                    _val = _val(this.environmentService, _currentRoute.params)
                }
                
                if(_val != null) _customizationStatus[i] = _val
            }
        }

        this.isHidden = _customizationStatus.hidden || false;
        this.footerLogo = _customizationStatus.logo || null;
        this.footerLarge = _customizationStatus.large || null;
    }

    removeNotification(notification:PGNotification) {
        let _index = this.notifications.indexOf(notification);

        if(_index != -1) {
            this.notifications.splice(_index, 1)
        }
    }

    hasSomething() {
        return this.hasErrors() || this.notifications.length > 0
    }

    hasErrors() {
        return (this.errorsComponent != null && this.errorsComponent.errors.length > 0);
    }

    @ViewChild('errorsComponent') errorsComponent:PgErrorsComponent

    getVersionsTable() {
        return this.environmentService.getVersionsTable();
    }

    getVersionString() {
        return this.environmentService.getVersionString();
    }

    copiedVersionsData = false;
    private _copiedVersionsDataTimeout = null;

    copyVersionsData() {
        clearTimeout(this._copiedVersionsDataTimeout)
        
        this.clipboardService.copyText(this.environmentService.getVersionsTable(true))

        this.copiedVersionsData = true;

        this._copiedVersionsDataTimeout = setTimeout(() => {
            this.copiedVersionsData = false;
        }, 1500)
    }

    @ViewChild('modalText') modalText:ElementRef;

    modalTextContent:'privacy-policy'|'terms-and-conditions' = null;

    private _modalRef:NgbModalRef = null;

    openModalText(text:'privacy-policy'|'terms-and-conditions') {
        this.modalTextContent = text;
        this._modalRef = this.modalService.open(this.modalText, { size: 'lg', modalDialogClass: 'PGModal-MaxHeight100' });
    }

    closeModalText() {
        this._modalRef.close()
    }
    
    private _getCurrentRealmId() {
        if(this.authService.isLoggedIn()) { 
            return this.authService.user.realm?.id;
        }
        else {
            return this.environmentService.publicRealm?.id;
        }
    }

    getPrivacyPolicyURL() {
        return this.localizationService.getPrivacyPolicyURL(this._getCurrentRealmId());
    }

    getTermsAndConditionsURL() {
        return this.localizationService.getTermsAndConditionsURL(this._getCurrentRealmId());
    }

    isCookieConsentAvailable() {
        return this.persistenceService.isConsentAvailable();
    }

    reviewCookies() {
        this.persistenceService.requestConsentReview();
    }

    canInstall() {
        return this.pwaInstallService.canInstall()
    }

    doInstall() {
        this.pwaInstallService.doInstall()
    }
}
